/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import dynamicScriptLoader from './DynamicScriptLoader'

export default {
  necessary: [
    {
      name: 'Cookie Consent Cookie',
      description: 'Mit ihnen wird der Cookie Consent Status gespeichert',
      cookies: ['cookie_control_consent', 'cookie_control_enabled_cookies'],
    },
    {
      name: 'Authentifizierungs Cookies für das Backend',
      description: 'Werden für die Authentifizierung im Backend benötigt',
      cookies: ['bolt_session', 'bolt_session'],
    },
  ],
  optional: [
    {
      name: 'Google Analytics',
      description: 'Wird für die Analyse der Nutzerinteraktionen mit der Website genutzt',
      src: 'https://www.google-analytics.com/analytics.js',
      async: true,
      cookies: ['_gat', '_gid', '_ga', '__gads'],
      accepted: () => {
        if (!window.GA_Property) {
          return
        }
        window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
        ga('create', window.GA_Property, 'auto');
        ga('send', 'pageview');
        ga('set', 'anonymizeIp', true);
      },
      declined: () => { },
    },
    {
      name: 'BFV Widget Cookies',
      description: 'Sind vorraussetzung für die Nutzung des BFV-Widgets',
      src: '',
      async: false,
      cookies: [
        'wt_nbg_Q3',
        'wt_cdbeid',
        'wt_nbg_Q3',
        'IDE'
      ],
      accepted: () => {
        dynamicScriptLoader('bfvwidget', (window.BFV_SCRIPT_URL || false))
      },
      declined: () => { },
    },
  ],
}
